module.exports = __webpack_public_path__ + "static/img/blancoT50_logo_zurqui.378237ec.png";